/**
 * defa.behaviors.ExpandSpoiler
 * A behavior for creating expandable control interfaces.
 * @version 1.2.0
 */

const selectors = {
	allModules    : '.expandable',  // !TODO: let the css-selector for siblings be available through the behavior options.
	expandToggle  : '[data-toggle=expand-spoiler]',
	expandSpoiler : '[data-container=expand-spoiler]',
};

const ExpandSpoiler = Mn.Behavior.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	ui: {
		toggle  : selectors.expandToggle,
		spoiler : selectors.expandSpoiler,
	},
	
	events: {
		'click @ui.toggle' : 'onClickToggle',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
		 * @constructor
		 */
	initialize: function() {
		
		// public
		this.view.expandToggle = this.expandToggle;
		this.view.expandOpen   = this.expandOpen;
		this.view.expandClose  = this.expandClose;
		
		// private
		this.view._isExpanded  = this._isExpanded;
		this.view._toggleSiblings = this._toggleSiblings;
	},
	
	/**
		 * Triggers when the user clicks the toggle button.
		 * @void
		 */
	onClickToggle: function( event ) {
		event.preventDefault();
		
		
		if ( Mn.getClosestCid( event.target ) !== this.view.cid ){
			return;
		}
		
		if ( this._isExpanded() ) {
			this.expandClose();
		} else {
			this.expandOpen();
		}
	},
	
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
		 * Toggles the view's expand state.
		 * @void
		 */
	expandToggle: function( expand ) {
		
		expand = expand || ! this._isExpanded();
		
		// toggle the buttons
		
		let expanders = this.$el.find( selectors.expandToggle );
		let cid       = ( this.view ) // should we rather toggle on instanceof View?
			? this.view.cid
			: this.cid;
			
		_.each( expanders, function( expander ) {
			
			if ( Mn.getClosestCid( expander ) === cid ){
				$( expander ).toggleClass( 'open', expand );
			}
		});
		
		// toggle the spoiler
		this.ui.spoiler.toggleClass( 'open', expand );
		
		// toggle hidden on other control modules
		this._toggleSiblings();
	},
	
	/**
		 * Sets the view in an open expand state.
		 * @void
		 */
	expandOpen: function() {
		this.expandToggle( true );
	},
	
	/**
		 * Sets the view in a closed expand state.
		 * @void
		 */
	expandClose: function() {
		this.expandToggle( false );
		
	},
	
	/**
		 * Checks if the view is in an expanded state.
		 * @return {bool}  True if the view is expanded, false if not.
		 */
	_isExpanded: function() {
		return this.ui.spoiler.hasClass( 'open' );
	},
	
	/**
		 * Toggle siblings based on this view's current state.
		 * !TODO: Added a little hack for now to exclude the general module from hiding. [WIP]
		 * @void
		 */
	_toggleSiblings: function() {
		
		this.$el.closest( selectors.allModules ).siblings().filter( selectors.allModules ).toggleClass( 'hidden', this.ui.spoiler.hasClass( 'open' ) );
		window.dispatchEvent(new CustomEvent('fix-switches', { 'detail': 'Example of an event' }));
	},
	
});

export default ExpandSpoiler;
